export default __webpack_public_path__ + "static/media/ico_arrow_up.ad412fa2.svg";